// extracted by mini-css-extract-plugin
export var radioInputRow = "t_rl";
export var radioInputColumn = "t_rm";
export var inputOptionRow = "t_pz";
export var inputOptionColumn = "t_pB";